import React, {
    useState,
    ReactElement,
    Dispatch,
    SetStateAction,
    useEffect
} from 'react'
import cn from 'classnames'
import s from './PromoBanner.module.scss'
import { useCookies } from 'react-cookie'

interface PromoBannerProps {
    maxAge?: number
    cookieName: string
    className?: string
    closeButton?: ReactElement | string
    setIsPromoCookieCleared?: Dispatch<SetStateAction<boolean>>
    isPromoCookieCleared?: boolean
}

export const PromoBanner: React.FC<PromoBannerProps> = ({
    children,
    cookieName,
    className,
    setIsPromoCookieCleared,
    isPromoCookieCleared
}) => {
    // The useCookies argument is called "dependencies"
    // Whenever these cookies are updated from any component, this component will re-render
    const [cookies, setCookie] = useCookies([cookieName])

    // `cookies` is an object with all of the app's cookies. The key is the cookie name
    // const [closed, setClosed] = useState(!!cookies[cookieName])
    useEffect(() => {
        if (setIsPromoCookieCleared) {
            setIsPromoCookieCleared(!!cookies[cookieName])
        }
    }, [])

    return (
        <div>
            {!isPromoCookieCleared && (
                <div className={cn(s['promo-banner'], className)}>
                    <div className={s['promo-banner-text']}>{children}</div>
                </div>
            )}
        </div>
    )
}
